import { render, staticRenderFns } from "./ticket-watchuser-list.vue?vue&type=template&id=31105cb2&scoped=true&"
import script from "./ticket-watchuser-list.vue?vue&type=script&lang=js&"
export * from "./ticket-watchuser-list.vue?vue&type=script&lang=js&"
import style0 from "./ticket-watchuser-list.vue?vue&type=style&index=0&id=31105cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31105cb2",
  null
  
)

export default component.exports